import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'm-formula-block',
  template: `
    <i nz-icon>
      <svg
        width="14px"
        height="14px"
        viewBox="0 0 14 14"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <g id="交互页面" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="09-03多表格及表文披露（单表合计）" transform="translate(-1034.000000, -287.000000)" fill="#555555" fill-rule="nonzero">
            <g id="-mockplus-" transform="translate(1011.000000, 198.000000)">
              <g id="编组" transform="translate(12.000000, 76.000000)">
                <g id="-mockplus-" transform="translate(11.000000, 13.000000)">
                  <g id="Icon/Line/universal/graph-delete" transform="translate(1.000000, 2.000000)">
                    <g id="formula" transform="translate(0.750000, 0.625000)">
                      <path
                        d="M2.0685,8.761375 L5.947375,4.79675 L2.076375,0.872375 L9.209375,0.872375 C9.447375,0.872375 9.639875,1.0675 9.639875,1.308125 L9.639875,1.743875 L10.5,1.743875 L10.5,1.308125 C10.5,0.585375 9.9225,0 9.209375,0 L0,0 L4.731125,4.79675 L0,9.625 L9.205,9.625 C9.9225,9.625 10.5,9.03875 10.5,8.316875 L10.5,7.84875 L9.639875,7.84875 L9.639875,8.316875 C9.639875,8.5575 9.447375,8.752625 9.209375,8.752625 L2.069375,8.761375 L2.0685,8.761375 Z"
                        id="路径"
                      ></path>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </i>
    <div class="m-formula-block-container">
      <div class="m-formula-block-key">
        <span>=</span>
        <div class="m-formula-block-key-content">
          <span>{{ mFormulaKey }}</span>
        </div>
      </div>
      <div class="m-formula-block-value">
        <span>=</span>
        <div class="m-formula-block-value-content">
          <span>{{ mFormulaValue }}</span>
        </div>
      </div>
      <div class="m-formula-block-correct">
        <span>=</span>
        <span class="correct-value">{{ mCorrectValue || '-' }}</span>
      </div>
      <div class="m-formula-block-error">
        <span>≠</span>
        <span class="not-equal" (click)="mClick.emit()">{{ mErrorValue || '-' }}</span>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  preserveWhitespaces: true,
  host: {
    class: 'm-formula-block'
  }
})
export class MFormulaBlockComponent {
  @Input() mFormulaKey: string = '';
  @Input() mFormulaValue: string = '';
  @Input() mErrorValue: string = '';
  @Input() mCorrectValue: string = '';

  @Output() readonly mClick = new EventEmitter<void>();
}
